
import { Vue, Component, Prop } from 'vue-property-decorator'
import { WPXFormValue } from '@/components/templates/WPXForm'
import IPBanFormData from '@/services/IPSet/Models/IPBanFormData'
import IPSetRepositoryInterface from '@/services/IPSet/Interfaces'

@Component({
  inject: ['ipsetRepository'],
})
export default class IPBanDialog extends Vue {
  public ipsetRepository!: IPSetRepositoryInterface;
  public refreshKey: number = 0;

  @Prop({ type: Boolean, required: true }) public readonly visible!: boolean;
  @Prop({ type: String, required: true }) public readonly listName!: string;
  @Prop({ type: Boolean, required: true }) public readonly counters!: boolean;
  @Prop({ type: Boolean, required: true }) public readonly skbInfo!: boolean;

  public ipBanForm: WPXFormValue<IPBanFormData> = new WPXFormValue(IPBanFormData)

  public async banIp(): Promise<void> {
    try {
      await this.ipsetRepository.banIp({
        set: this.listName,
        ip: this.ipBanForm.data.ip,
        timeout: Number(this.ipBanForm.data.timeout),
        comment: this.ipBanForm.data.comment,
        packets: Number(this.ipBanForm.data.packets),
        bytes: Number(this.ipBanForm.data.bytes),
        skbMark: this.ipBanForm.data.skbMark,
        skbPrio: this.ipBanForm.data.skbPrio,
        skbQueue: Number(this.ipBanForm.data.skbQueue),
      })
    } catch (err) {
      this.$errorDialog.show(err.request.response.error)

      return
    }

    this.$emit('ipBanned', {
      ip: this.ipBanForm.data.ip,
      timeout: this.ipBanForm.data.timeout,
      comment: this.ipBanForm.data.comment,
      packets: this.ipBanForm.data.packets,
      bytes: this.ipBanForm.data.bytes,
      skbMark: this.ipBanForm.data.skbMark,
      skbPrio: this.ipBanForm.data.skbPrio,
      skbQueue: this.ipBanForm.data.skbQueue,
    })

    this.$successDialog.show(`Successfully added ${this.ipBanForm.data.ip} to the list.`)
    this.closeDialog();
  }

  public closeDialog(): void {
    this.refreshKey++;
    this.ipBanForm.resetData()
    this.$emit('close');
  }
}

